import React from 'react';

const NotFound = () => {
  return (
    <div className='not_found_container'>
      <div>Sorry :(</div>
      <div>Page Not Found</div>
    </div>
  );
};

export default NotFound;
